import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import { RepoCreateInput } from "types/generated";

import { CREATE_SPACELIFT_VCS_REPO } from "./gql";
import { SEARCH_SPACELIFT_VCS_REPOS } from "../useSpaceliftVcsReposList/gql";

const useCreateSpaceliftVcsRepoMutation = createDefaultMutationHook(CREATE_SPACELIFT_VCS_REPO);

const useCreateSpaceliftVcsRepo = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [mutation, { loading }] = useCreateSpaceliftVcsRepoMutation({
    refetchQueries: [SEARCH_SPACELIFT_VCS_REPOS],
  });

  const createSpaceliftVcsRepo = useCallback(
    (input: RepoCreateInput, onSuccess?: () => void) => {
      mutation({ input }, (data) => {
        if (data?.repoCreate) {
          reportSuccess({ message: "Repo created successfully" });
          onSuccess?.();
        }
      });
    },
    [mutation, reportSuccess]
  );

  return {
    createSpaceliftVcsRepo,
    loading,
  };
};

export default useCreateSpaceliftVcsRepo;
